// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false, 
  firebase: {
    apiKey: "AIzaSyDcPw-uFWK1BZH2BNdCh0J1s1Fo8Q-vyvE",
    authDomain: "raiffeisen-sso-login.firebaseapp.com",
    databaseURL: "https://raiffeisen-sso-login.firebaseio.com",
    projectId: "raiffeisen-sso-login",
    storageBucket: "raiffeisen-sso-login.appspot.com",
    messagingSenderId: "710976716378",
    appId: "1:710976716378:web:33af36068779b1998d2263",
    measurementId: "G-S63XHECXTW"
  }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
